import dayjs from 'dayjs';

import styles from './BlogHeader.module.scss';

export const BlogHeader = ({
  title,
  author,
  date,
}: {
  title: string;
  author: string;
  date: Date | null;
}) => {
  return (
    <div
      className={`bg-primary-500 br8 tc-white px16 py80 ${styles.container}`}
    >
      <div className={styles.content}>
        <h1 className="p-h1--xl p--serif tc-white">{title}</h1>
        <div className="mt16">
          <span>{author}</span>
          <span className="ml24">
            {date ? dayjs(date).format('MMM D, YYYY') : ''}
          </span>
        </div>
      </div>
    </div>
  );
};
